<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import tableMixin from '@/helpers/mixins/table' 

export default {
    page: {
        title: "Sökülemeyen Listesi",
    },
    mixins: [ tableMixin ],
    components: {
        Layout,
        PageHeader,
    },
    computed: {
       ...mapGetters('authfack',['userdata'])
    },
    data() {
     return {
        title: "SÖKÜLEMEYEN LİSTESİ",
        items: [
            { text: "ANASAYFA", href: "/" },
            { text: "SÖKÜLEMEYEN LİSTESİ", active: true }
        ],
        url: "/listeler/sokum-listesi?status=8",
        buttons:[
            { title:"Geri Al", icon:'bx bx-refresh', func:this.cikart},
        ],  
        columns: [
                    {
                        field: '#',
                        sortable: false,
                        thClass: 'width-50',
                    }, 
                    {
                        label: 'Kullanıcı Adı',
                        field: 'username',
                        sortable: false,
                    },
                    {
                        label: 'İsim Soyisim',
                        field: "fullname",
                    },
                    {
                        label: 'Bitiş Tarihi',
                        field: this.expiredate,
                    },
                    {
                        label: 'Cep Telefonu',
                        field: this.phonenumber,
                        html: true,
                        sortable: false,
                    },
                    {
                        label: 'Whatsapp',
                        field: this.whatsapp,
                        html: true,
                        sortable: false,
                    },
                    {
                        label: 'İl',
                        field: "province",
                        sortable: false,
                    }, 
                    {
                        label: 'Bölge',
                        field:  "township",
                        sortable: false,
                    },
                    {
                        label: 'Adres',
                        field:  "address",
                        sortable: false,
                    }, 
                ],
        };
    },
    mounted(){
        document.getElementById('vgt-table').style.marginBottom = '150px'
    },
    methods: {
        expiredate(obj){
            return this.formatDate(obj.expiredate, "DD.MM.YYYY HH:mm")
        },
        phonenumber(obj){
            const url =   obj.phonenumber;
            return `<a href=tel:'${url}'  >${obj.phonenumber}</a>`
        },
        whatsapp(obj){
            if(!obj.phonenumber2) return
            const url =  "https://wa.me/" + obj.phonenumber2;
            return `<a target="_blank" href='${url}'  >${obj.phonenumber2}</a>`
        },
        cikart(props){
            this.$http.post('/listeler/uzatmayanlar/event', { cikart : props.id })
            .then(() => this.loadItems())
        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />
    <vue-good-table
        mode="remote"
        styleClass="vgt-table bordered condensed"
        :line-numbers="true" 
        :total-rows="totalRecords"
        :columns="columns"
        :rows="rows"
        :pagination-options="paginationOptions"
        :is-loading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange">
        <template slot="loadingContent">
        <div>Yükleniyor</div>
        </template>
            <template
            slot="table-row"
            slot-scope="props"
            >
            <span
                v-if="props.column.field === '#'"
                class="text-nowrap"
            >
              <b-dropdown
                class="ms-2 "
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                right
              >
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <template   
                  v-for="(button,i) in buttons" >
                  <b-dropdown-item 
                    :key="i" 
                    @click="button.func(props.row)">
                    <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                  </b-dropdown-item>
                  </template>
              </b-dropdown>
            </span>
        </template>
    </vue-good-table>
  </Layout>
</template>